import HamburgerMenu from './component/hamburgerMenu';
// import SmoothScroll from './component/smoothScroll';
// import Accordion from './component/accordion';
import PageTop from './component/pageTop';
import { scrollAnimation } from './module/scrollAnimation';

window.addEventListener('load', () => {
  new HamburgerMenu().handleClick('js-hamburger');
  // new SmoothScroll();
  // new Accordion.init(".js-accordionBtn");
  new PageTop();
  scrollAnimation();
});
